import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { QRCodeCanvas } from '@cian/frontend-qrcode';
import { CustomTooltip, UIHeading3, UIText2 } from '@cian/ui-kit';

import { trackViewQRCode } from './analytics';

import * as styles from './PhoneLinkQRCode.css';
import { useApplicationContext } from '../../utils/applicationContext';

interface IQRCodePhone {
  phoneLink: string;
  formattedPhone: string;
}

const COLOR_QR_CANVAS = {
  // Во время миграций важно сохранить hex-значения цветов для библиотеки @cian/frontend-qrcode.
  dark: '#152242',
  light: '#ffffff',
};

export const PhoneLinkQRCode = ({ phoneLink, formattedPhone }: IQRCodePhone) => {
  const { logger } = useApplicationContext();
  const anchorRef = React.useRef(null);
  const [open, setOpenState] = React.useState(false);
  const [openedOnce, setOpenedOnce] = React.useState(false);

  const setOpen = React.useCallback(() => {
    setOpenState(true);

    /* istanbul ignore else */
    if (!openedOnce) {
      trackViewQRCode();
      setOpenedOnce(true);
    }
  }, [setOpenState, trackViewQRCode, openedOnce, setOpenedOnce]);
  const setClose = React.useCallback(() => setOpenState(false), [setOpenState]);

  return (
    <ErrorLogComponent logger={logger}>
      <CustomTooltip
        open={open}
        placement="left-end"
        maxWidth={190}
        anchorRef={anchorRef}
        content={
          <div data-testid="phoneLinkQrCode" className={styles['container']}>
            <div className={styles['code']}>
              <QRCodeCanvas id="phoneLinkQrCode" width={166} text={phoneLink} color={COLOR_QR_CANVAS} />
            </div>
            <div className={styles['description']}>
              <UIHeading3>{formattedPhone}</UIHeading3>
              <UIText2 color="black_60">Просто наведите камеру, чтобы набрать номер</UIText2>
            </div>
          </div>
        }
        closeButton={false}
        onMouseLeave={setClose}
      />
      <div
        data-testid="qrCodeImg"
        className={styles['static-preview']}
        onMouseEnter={setOpen}
        onMouseLeave={setClose}
        ref={anchorRef}
      />
    </ErrorLogComponent>
  );
};
